/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const casesByPIDAndCreatedAtShallow = /* GraphQL */ `query CasesByPIDAndCreatedAtShallow(
    $pID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    casesByPIDAndCreatedAt(
      pID: $pID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        pID
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        templateData
        typedNotes
        recordings {
          items {
            id
            name
            storagePath
            text
            summary
            segments
            lID
            cID
            owners
            createdAt
            _version
            _deleted
          }
        }
        details {
          items {
            id
            type
            text
            summary
            isSummarized
            pID
            cID
            groups
            owners
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        caseTemplateId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
  ` as GeneratedQuery<
  APITypes.CasesByPIDAndCreatedAtQueryVariables,
  APITypes.CasesByPIDAndCreatedAtQuery
>;